import { channelTypeInfo } from "../../models/ChannelType";
import Floor from "../../models/Floor";
import type Room from "../../models/Room";
import { SequenceStep, enumActions } from "../Guide";
import GuideUtils from "../GuideUtils";

export default function openRoomOrFloorSequence(elm: {
  connectableClassNameIn?: Array<string>;
  roomGiven?: Room | Floor;
}): Array<SequenceStep> {
  const { connectableClassNameIn, roomGiven } = elm;
  let room = roomGiven || GuideUtils.openRoom();
  if (room == undefined) {
    state.floors.forEach((floor) => {
      floor.rooms.forEach((room1) => {
        if (room == undefined) {
          let isInRoom = false;
          connectableClassNameIn?.forEach((className) => {
            if (className == "Button") {
              if (room1.buttons.asArray()[0]) {
                isInRoom = true;
              }
            } else if (className == "Consumer") {
              room1.consumers.forEach((cons) => {
                if (channelTypeInfo(cons.channelType).isLight) {
                  isInRoom = true;
                }
              });
            }
          });
          if (isInRoom) {
            room = room1;
          }
        }
      });
    });
  }
  if (room && state.activePaneId != room.page?.id) {
    return [
      {
        action: enumActions.function,
        func: async (): Promise<void> => {
          state.selectionManager.selectedObject = room;
        },
      },
      { action: enumActions.wait },
      {
        action: enumActions.focus,
        id: () => {
          return `tv-${room?.id}`;
        },
      },
      {
        action: enumActions.click,
        id: () => {
          return [`tv-${room?.id}`, room?.className == "Room" ? `inlineButton_editRoom` : `inlineButton_editFloor`];
        },
      },
    ];
  }
  return [];
}

export function openFloorEditRooms(elm: {}): Array<SequenceStep> {
  const activePage = state.getActivePage();
  if (activePage?.editRooms && activePage.isFloorPlan) {
    return [
      {
        action: enumActions.click,
        id: () => {
          return [`editRooms`];
        },
      },
      // {
      //   action: enumActions.function,
      //   func: async (): Promise<void> => {
      //     state.selectionManager.selectedObject = room;
      //   },
      // },
      // { action: enumActions.wait },
      // {
      //   action: enumActions.focus,
      //   id: () => {
      //     return `editRooms`;
      //   },
      // },
    ];
  }
  return [];
}
